import { render, staticRenderFns } from "./scHeader.vue?vue&type=template&id=dddadedc&scoped=true&"
import script from "./scHeader.vue?vue&type=script&lang=js&"
export * from "./scHeader.vue?vue&type=script&lang=js&"
import style0 from "./scHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./scHeader.vue?vue&type=style&index=1&id=dddadedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddadedc",
  null
  
)

export default component.exports